export function formatCurrency(value: number, currency = "USD"): string {
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency,
      maximumFractionDigits: 2,
    }).format(value);
  } catch {
    return `${value.toFixed(2)} ${currency}`;
  }
}

export function formatNumber(value: number): string {
  return new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(value);
}

export function formatPct(value: number | null): string {
  if (value === null) return "n/a";
  const sign = value > 0 ? "+" : "";
  return `${sign}${value.toFixed(1)}%`;
}

const BYTE_UNITS = ["B", "KB", "MB", "GB", "TB"];

export function formatBytes(value: number): string {
  if (value === 0) return "0 B";
  const i = Math.min(Math.floor(Math.log(Math.abs(value)) / Math.log(1024)), BYTE_UNITS.length - 1);
  return `${(value / 1024 ** i).toFixed(1)} ${BYTE_UNITS[i]}`;
}

export function formatMetricValue(value: number | null, unit: string): string {
  if (value === null) return "--";
  switch (unit) {
    case "Percent":
      return `${value.toFixed(1)}%`;
    case "Bytes":
      return formatBytes(value);
    case "Seconds":
      return `${(value * 1000).toFixed(0)} ms`;
    default:
      return formatNumber(value);
  }
}

export function formatTime(iso: string | null): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    month: "short",
    day: "numeric",
  });
}
